import * as requests from '../requests/heatmaps'
import { loadingData , dataLoaded } from './app'
import { changeSliderPosition } from "./slider";
import {removeAQI} from "./analytics";
import { fetchSensorsFromTimestamp } from "./sensors"

export const FETCH_HEATMAPS = 'FETCH_HEATMAPS'
export const ADD_HEATMAP = 'ADD_HEATMAP'
export const DELETE_HEATMAPS = 'DELETE_HEATMAPS'
export const CHANGE_HEATMAP_DISPLAY = 'CHANGE_HEATMAP_DISPLAY'
export const MAP_LOADED ='MAP_LOADED'
export const MAP_ERROR = 'MAP_ERROR'

export const fetchAllHeatmaps = (resolve, admin, map, hours) => {
    return dispatch => {
        requests.fetchHeatmaps(map, hours, (heatmaps) => {
            if(admin)
                heatmaps = [heatmaps[heatmaps.length - 1]];
            dispatch({
                type: FETCH_HEATMAPS,
                heatmaps
            })
            dispatch(changeSliderPosition(heatmaps.length - 1))
            resolve()
        })

    }
}

export const addHeatmap = (heatmap) => {
    return (dispatch, getStore) => {
        const { heatmaps } = getStore()
        dispatch(changeSliderPosition(heatmaps.list.length))
        dispatch({
            type: ADD_HEATMAP,
            heatmap
        })
    }
}

export const generateHeatmap = (callback) => {
    return dispatch => {
        dispatch(loadingData())
        requests.generateHeatmap(heatmap => {
            dispatch(addHeatmap(heatmap))
            dispatch(dataLoaded())
            dispatch(fetchSensorsFromTimestamp(heatmap.timestamp))
        })
    }
}

export const deleteHeatmaps = () => {
    return dispatch => {
        dispatch(removeAQI())
        requests.deleteAllHeatmaps(() => {
            dispatch({
                type: DELETE_HEATMAPS
            })
        })
    }
}

export const changeHeatmapDisplay = (position) => {
    return (dispatch, getStore) => {
        const { heatmaps, analytics } = getStore()
        dispatch({
            type: CHANGE_HEATMAP_DISPLAY,
            position
        })

    }
}

export const increaseLoadedMaps =()=>{
    return{
        type: MAP_LOADED
    }
}

export const errorOnMap = (error) => {
    return {
        type: MAP_ERROR,
        error
    }
}


// WEBPACK FOOTER //
// ./src/actions/heatmaps.js